import { Default } from "@master/annotation/Default";

export class GroupDetailsDTO {
  name: string;
  accessViews: string[] = []
  userOids: string[] = []
  selectedRoleIds?: string[] = []
  backendChecker?: string;
}
